import { PartyIdentifierDTO } from 'support/types';

const BACKEND_KEY_TO_DOMAIN: ReadonlyArray<readonly [string, PartyIdentifierDTO['domain']]> = [
  ['gln', 'GS1'],
  ['vat', 'vatID'],
  ['duns', 'DUNS'],
  ['federal_tax', 'federalTaxID'],
  ['sender_internal', 'internal'],
  ['receiver_internal', 'internal'],
  ['vvvo', 'VVVO'],
  ['veterinary', 'veterinary'],
  ['organic_control_point_number', 'organicControlPointNumber'],
];

export const parseEphemeralPartnerIdentifiers = (raw: unknown): Array<PartyIdentifierDTO> => {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return [];
  }
  const source = raw as Record<string, unknown>;
  const seenDomains = new Set<PartyIdentifierDTO['domain']>();
  const out: Array<PartyIdentifierDTO> = [];

  for (const [backendKey, domain] of BACKEND_KEY_TO_DOMAIN) {
    const value = source[backendKey];
    if (typeof value !== 'string') {
      continue;
    }
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      continue;
    }
    if (seenDomains.has(domain)) {
      continue;
    }
    seenDomains.add(domain);
    out.push({ domain, identifier: trimmed });
  }

  return out;
};
